import HotkeysDisplay from './HotkeysDisplay';

export default HotkeysDisplay;
